export default "__VITE_ASSET__ba7a5f4d__"